export const STORAGE_REPOSITORY_TYPE = {
  GCS: "gcs",
  S3: "s3",
  FS: "fs",
  HDFS: "hdfs",
  ABS: "azure"
};
